const MAX_LENGTH = 45;
const TAIL_LENGTH = 6;

/**
 * Truncate long filenames preserving the extension and a tail segment.
 * "very_long_document_name_here.pdf" -> "very_long_doc...e_here.pdf"
 */
export const truncateFileName = (name: string, maxLen = MAX_LENGTH): string => {
  if (name.length <= maxLen) return name;

  const dotIdx = name.lastIndexOf('.');
  const ext = dotIdx > 0 ? name.slice(dotIdx) : '';
  const base = dotIdx > 0 ? name.slice(0, dotIdx) : name;
  const availableStart = maxLen - TAIL_LENGTH - ext.length - 1;

  if (availableStart < 4) return `${name.slice(0, maxLen - 1)}\u2026`;

  return `${base.slice(0, availableStart)}\u2026${base.slice(-TAIL_LENGTH)}${ext}`;
};
